import './icons/';
import './iconfont/rticonfont.css';



// WEBPACK FOOTER //
// ./~/vue-xpc/src/assets/index.js